/**
 * How a receptionist groups the ways somebody reaches them, which is not how
 * the activities table does. A text and a call are the same handset, so they
 * are one box to tick; `toTaskFilters` is where a bucket becomes the channels
 * the server knows about.
 *
 * Its own module, with no imports, because the route's search schema is built
 * from it and everything that reads that schema is reached from the route. Any
 * of them exporting it back would put the search type in a cycle with itself,
 * which TypeScript resolves by giving up and calling it `any`.
 */
export const CHANNEL_BUCKETS = ['phone', 'email', 'form'] as const;

export type ChannelBucket = (typeof CHANNEL_BUCKETS)[number];

/** What each bucket means to the server, which knows only activity types. */
export const BUCKET_CHANNELS = {
  phone: ['call', 'sms'],
  email: ['email'],
  form: ['formSubmission'],
} as const satisfies Record<ChannelBucket, ReadonlyArray<string>>;
